module.exports = __webpack_public_path__ + "img/Recurso 5.ecf5aaa0.png";